export const fundRankingConstants = {
  SET_CURRENT_FUND_RANKING_PAGE: 'SET_CURRENT_FUND_RANKING_PAGE',
  SET_TOTAL_RANKING_PAGE: 'SET_TOTAL_RANKING_PAGE',

  UPDATE_FUND_RANKING_QUERIES: 'UPDATE_FUND_RANKING_QUERIES',
  RESET_FUND_RANKING_QUERIES: 'RESET_FUND_RANKING_QUERIES',

  UPDATE_FUND_RANKING_TABLE_COLUMNS: 'UPDATE_FUND_RANKING_TABLE_COLUMNS',

  SET_DEFAULT_FUND_RANKING_QUERIES: 'SET_DEFAULT_FUND_RANKING_QUERIES',

  FETCH_RANK_START: 'FETCH_RANK_START',
  FETCH_RANK_SUCCESS: 'FETCH_RANK_SUCCESS',
  FETCH_RANK_FAILURE: 'FETCH_RANK_FAILURE',

  SET_FUND_ID_RANK: 'SET_FUND_ID_RANK',
  FETCH_FUND_RANK_START: 'FETCH_FUND_RANK_START',
  FETCH_FUND_RANK_SUCCESS: 'FETCH_FUND_RANK_SUCCESS',
  FETCH_FUND_RANK_FAILURE: 'FETCH_FUND_RANK_FAILURE',

  FETCH_RANK_SEARCH_FILTERS_START: 'FETCH_RANK_SEARCH_FILTERS_START',
  FETCH_RANK_SEARCH_FILTERS_SUCCESS: 'FETCH_RANK_SEARCH_FILTERS_SUCCESS',
  FETCH_RANK_SEARCH_FILTERS_FAILURE: 'FETCH_RANK_SEARCH_FILTERS_FAILURE',

  FETCH_RANKINGS_START: 'FETCH_RANKINGS_START',
  FETCH_RANKINGS_SUCCESS: 'FETCH_RANKINGS_SUCCESS',
  FETCH_RANKINGS_FAILURE: 'FETCH_RANKINGS_FAILURE',

  SET_NAV_TYPE_RANKING : 'SET_NAV_TYPE_RANKING',
  UPDATE_NAV_DATE_FUND_RANKING: 'UPDATE_NAV_DATE_FUND_RANKING',
  FETCH_NAV_RANKINGS_START: 'FETCH_NAV_RANKINGS_START',
  FETCH_NAV_RANKINGS_SUCCESS: 'FETCH_NAV_RANKINGS_SUCCESS',
  FETCH_NAV_RANKINGS_FAILURE: 'FETCH_NAV_RANKINGS_FAILURE',

  SET_HIGHLIGHT_FUND_PERIOD: 'SET_HIGHLIGHT_FUND_PERIOD',
  FETCH_HIGHLIGHT_FUND_START: 'FETCH_HIGHLIGHT_FUND_START',
  FETCH_HIGHLIGHT_FUND_SUCCESS: 'FETCH_HIGHLIGHT_FUND_SUCCESS',
  FETCH_HIGHLIGHT_FUND_FAILURE: 'FETCH_HIGHLIGHT_FUND_FAILURE',

  FETCH_CATEGORIES_START: 'FETCH_CATEGORIES_START',
  FETCH_CATEGORIES_SUCCESS: 'FETCH_CATEGORIES_SUCCESS',
  FETCH_CATEGORIES_FAILURE: 'FETCH_CATEGORIES_FAILURE',

  UPDATE_CATEGORIES: 'UPDATE_CATEGORIES',
  APPEND_CATEGORY: 'APPEND_CATEGORY',
  REMOVE_CATEGORY: 'REMOVE_CATEGORY',

  FETCH_USER_CATEGORIES_START: 'FETCH_USER_CATEGORIES_START',
  FETCH_USER_CATEGORIES_SUCCESS: 'FETCH_USER_CATEGORIES_SUCCESS',
  FETCH_USER_CATEGORIES_FAILURE: 'FETCH_USER_CATEGORIES_FAILURE',
  UPDATE_USER_CATEGORIES: 'UPDATE_USER_CATEGORIES',
  RESET_USER_CATEGORIES: 'RESET_USER_CATEGORIES',

  SAVE_USER_CATEGORIES_START: 'SAVE_USER_CATEGORIES_START',
  SAVE_USER_CATEGORIES_SUCCESS: 'SAVE_USER_CATEGORIES_SUCCESS',
  SAVE_USER_CATEGORIES_FAILURE: 'SAVE_USER_CATEGORIES_FAILURE',
};
